function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState, useEffect } from "react";
import { List, Skeleton, Card, Tag, Input } from "antd";
import Common from "./includes/Common";
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
var Meta = Card.Meta;
var ConsumablesGrid = function ConsumablesGrid(_ref) {
  var selectHandler = _ref.selectHandler;
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    pList = _useState2[0],
    setPList = _useState2[1];
  var _useState3 = useState(true),
    _useState4 = _slicedToArray(_useState3, 2),
    isDataLoading = _useState4[0],
    setIsDataLoading = _useState4[1];
  var _useState5 = useState("TOUS"),
    _useState6 = _slicedToArray(_useState5, 2),
    svalue = _useState6[0],
    setSvalue = _useState6[1];
  var _useState7 = useState('0'),
    _useState8 = _slicedToArray(_useState7, 2),
    searchWord = _useState8[0],
    setSearchWord = _useState8[1];
  var handleSegmentChange = function handleSegmentChange(v) {
    setSvalue(v.toString());
  };
  var onSearch = function onSearch(v) {
    if (v.target.value.length > 0) {
      setSearchWord(v.target.value);
    }
  };
  useEffect(function () {
    console.log(searchWord.toString());
    setIsDataLoading(true);
    axios.get(Common.baseApiUrl + "getconsumables/" + Common.currentUser.id + "/" + svalue + "/" + searchWord.toString()).then(function (response) {
      setPList([]);
      if (response.data.status == 200) {
        response.data.products.forEach(function (element) {
          setPList(function (prev) {
            return [].concat(_toConsumableArray(prev), [{
              id: element.id,
              label: element.label,
              cost_price: element.cost_price,
              available_quantity: element.available_quantity,
              minimal_stock: element.minimal_stock
            }]);
          });
        });
      }
    })["catch"](function (error) {
      message.error({
        content: "Une erreur est survenue",
        delay: 4
      });
    })["finally"](function () {
      setIsDataLoading(false);
    });
  }, [searchWord, svalue]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Input, {
      placeholder: "Nom de l'article",
      size: "large",
      onChange: onSearch,
      style: {
        width: '100%',
        marginBottom: '20px'
      }
    }), /*#__PURE__*/_jsx("br", {}), isDataLoading ? /*#__PURE__*/_jsx(Skeleton, {
      active: true
    }) : /*#__PURE__*/_jsx(List, {
      grid: {
        gutter: 16,
        column: 3
      },
      dataSource: pList,
      renderItem: function renderItem(item) {
        return /*#__PURE__*/_jsx(List.Item, {
          onClick: function onClick() {
            selectHandler(item);
          },
          children: /*#__PURE__*/_jsx(Card, {
            style: {
              cursor: "pointer"
            },
            children: /*#__PURE__*/_jsx(Meta, {
              title: /*#__PURE__*/_jsx("b", {
                children: item.label
              }),
              description: /*#__PURE__*/_jsx(Tag, {
                color: "#f50"
              })
            })
          })
        });
      }
    })]
  });
};
export default ConsumablesGrid;